import axiosInstance from '@/api/axiosInstance';

const actions = {
  async login({ commit }, payload) {
    try {
      const url = '/administradores/login';

      const response = await axiosInstance.post(url, payload);

      if (response?.status === 200) {
        const data = response.data;

        if (data.status) {
          const timestamp = new Date().getTime();
          localStorage.setItem('admin', data.payload);
          localStorage.setItem('adminToken', data.payload.token);
          localStorage.setItem('adminTokenTime', timestamp);
        }

        commit('SET_DATA', { key: 'formSend', data: true });
        return data;
      } else {
        throw new Error('No se pudo obtener la información de la api.');
      }
    } catch (error) {
      console.error('Error al crear la petición:', error);
      throw error;
    }
  },
  async validate({ commit }, payload) {
    try {
      const url = '/administradores/validate';

      const response = await axiosInstance.post(url, payload);

      if (response?.status === 200) {
        const data = response.data;

        if (data.status) {
          commit('SET_DATA', { key: 'admin', data: data.data });
        }

        commit('SET_DATA', { key: 'formSend', data: true });
        return data;
      } else {
        throw new Error('No se pudo obtener la información de la api.');
      }
    } catch (error) {
      console.error('Error al crear la petición:', error);
      throw error;
    }
  },
};

export default actions;